export default __webpack_public_path__ + "static/butterfly-47d2d89d610d362740e4f9f2d7bf88fd.svg";